import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { EmojiPickerProps } from './EmojiPicker.tsx';

export const EmojiPickerLoader: LoadableType<EmojiPickerProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EmojiPicker" */ './EmojiPicker.tsx')).EmojiPicker,
});
